module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en_US":{"upload":"Upload a file"},"fr_FR":{"upload":"Téléverser un fichier"}}')
  delete Component.options._Ctor
}
